// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"xY-z","sponsoredTooltipWrapper":"yY-z","sponsoredTooltip":"zY-z","newCard":"AY-z"};